/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Created by seaster on 2/1/16.
 */

'use strict';

angular.module('prism-ui.package').service('PackageLiveClipViewService',
    function (
        $filter,
        $interval,
        $location,
        $q,
        moment,
        timecodeFromSecFilter,
        ClipResourceFactory,
        ContentResourceFactory,
        DownloadAssetService,
        DynamicPropertiesService,
        EndPointService,
        LiveClipResourceFactory,
        PackagePropertiesQueryService,
        PackageResourceFactory,
        PackageUtilService,
        PartnerPackagesService,
        PermissionsService,
        PreviewQueryService,
        RecordResourceFactory,
        SystemMediainfoResource
    ) {
        var self = this, clipsInterval = null, recordInterval = null;

        var PACKAGE_AD_HOC_ADD_PARTNERS_VIEW_STATE = 'PACKAGE_AD_HOC_ADD_PARTNERS_VIEW_STATE';
        var CLIP_TABS_VIEW_STATE = 'PACKAGE_VIDEO_CLIPS_VIEW_STATE';
        var ADVANCED_LIVE_CLIP_PACKAGE_DISTRIBUTIONGRID_VIEW_STATE = 'ADVANCED_LIVE_CLIP_PACKAGE_DISTRIBUTIONGRID_VIEW_STATE';
        var CLIP_COLLABORATORS_VIEW_STATE = 'CLIP_COLLABORATORS_VIEW_STATE';
        var CLIP_DISTRIBUTIONGRID_VIEW_STATE = 'CLIP_DISTRIBUTIONGRID_VIEW_STATE';
        var DOWNLOAD_PROXY_STATE = 'CLIP_ACTION_DOWNLOAD_PROXIES_VIEW_STATE';

        self.originalClipEditData = {};
        self.viewModel = {
            perms: {
                livePerms: false,
                collabPerms: false,
                distPerms: false,
                advancedDistPerms: false,
                adHocPerms: false
            },
            record: null,
            clips: [],
            draftClips: [],
            totalClipsDuration: 0,
            currentFeed: {},
            clipInEdit: {},
            feedScheduleMap: {},
            availableFeeds: [],
            showClipsLoading: false
        };

        self.currentSchedule = {};
        self.categoryTypes = [];
        self.includeHidden = false;
        self.packageMedia = null;

        var filterClipValidationResults = function (validationResult) {
            var valResults = angular.copy(validationResult);
            angular.forEach(valResults, function (result) {
                result.errors = result.errors.filter(function (error) {
                    return error.hasOwnProperty('member');
                });
                result.warnings = result.warnings.filter(function (warning) {
                    return warning.description.indexOf('Original Release Date') === -1;
                });
            });
            return valResults;
        };

        var setupClips = function (clips) {
            self.viewModel.clips.length = 0;
            self.viewModel.draftClips.length = 0;
            self.viewModel.totalClipsDuration = 0;
            angular.forEach(clips, function (clip) {
                clip.validationResult = filterClipValidationResults(clip.validationResult);
                if (clip.clipStartOffset > -1 && clip.clipEndOffset > -1) {
                    clip.clipDuration = clip.clipEndOffset - clip.clipStartOffset;
                    self.viewModel.totalClipsDuration += clip.clipDuration;
                    self.viewModel.clips.push(clip);
                } else {
                    self.viewModel.draftClips.push(clip);
                }
            });
        };

        var getClipDeliveryWorkflows = function (parentPackageId) {
            return PackageResourceFactory.deliveryWorkflows({
                id: parentPackageId,
                includeClips: true
            }).$promise.then(function (deliveryList) {
                var deliveryWorkflowMap = {};
                angular.forEach(deliveryList, function (deliveryWorkflow) {
                    deliveryWorkflowMap[deliveryWorkflow.packageId] = deliveryWorkflow.deliveryWorkflowProgress;
                });
                return deliveryWorkflowMap;
            });
        };

        self.refreshClips = function () {
            if (!self.packageObject) {
                return;
            }

            self.viewModel.showClipsLoading = true;

            return $q.all({
                clips: PackageResourceFactory.getClips({id: self.packageObject.id, includeHidden: self.includeHidden}).$promise,
                deliveries: getClipDeliveryWorkflows(self.packageObject.id),
                dynamicProperties: DynamicPropertiesService.queryForProperties()
            }).then(function (resolved) {
                $interval.cancel(clipsInterval);
                self.viewModel.deliveryProgressMap = resolved.deliveries;
                setupClips(resolved.clips);

                clipsInterval = $interval(self.refreshClips, self.getClipRefreshInterval());
                self.viewModel.showClipsLoading = false;
                return resolved.clips;
            });
        };

        var delayedPollForClips = function (promiseToResolve) {
            self.refreshClips().then(function () {
                promiseToResolve.resolve();
            });
        };

        var pollForRecord = function () {
            self.viewModel.record = RecordResourceFactory.get({id: self.currentSchedule.liveRecordId});
            self.viewModel.record.$promise.then(function (record) {
                if (record.status === 'complete' || record.status === 'error') {
                    $interval.cancel(recordInterval);
                }
            });
            return self.viewModel.record.$promise;
        };

        var handleRecordSuccess = function (record) {
            if (record.status !== 'complete' && record.status !== 'error') {
                $interval.cancel(recordInterval);
                recordInterval = $interval(pollForRecord, 30000);
            }
        };

        var createDraftClipName = function (clipTitle) {
            self.draftClipTitle = self.packageObject.content.prefix + ' ' +
                self.packageObject.productionNumber + ' ' +
                clipTitle;
        };

        self.getRecordData = function (recordId) {
            self.viewModel.record = RecordResourceFactory.get({id: recordId});
            self.viewModel.record.$promise.then(function (recordData) {
                handleRecordSuccess(recordData);
            });
            return self.viewModel.record.$promise;
        };

        self.getClipRefreshInterval = function () {
            return DynamicPropertiesService.getPropValueAsInt('liveClipping.clipRefreshInterval', 10000);
        };

        var getRecordAndClipData = function (recordId) {
            var clipPromise = self.refreshClips();
            var recordPromise = self.getRecordData(recordId);
            return $q.all({clips: clipPromise, record: recordPromise});
        };

        var buildFeedScheduleMap = function (feeds, schedules) {
            var feedSchedules = {};
            var feed = null;
            var schedule = null;
            for (var i = 0; i < feeds.length; i++) {
                feed = feeds[i];
                for (var j = 0; j < schedules.length; j++) {
                    schedule = schedules[j];
                    if (feed.id === schedule.showLiveFeedId) {
                        feedSchedules[feed.id] = {feed: feed, schedule: schedule};
                        break;
                    }
                }
            }
            return feedSchedules;
        };

        self.setAvailableTextTracks = function () {
            var defaultCCTrack = null;

            if (self.packageMedia && self.packageMedia.cc) {
                defaultCCTrack = self.packageMedia.cc.filter(function (ccMedia) {
                    return ccMedia.languageId === self.packageMedia.video[0].languageId &&
                        ccMedia.dropdownLabel.toLowerCase().indexOf('spoken language') > -1;
                })[0];
            }
            if (defaultCCTrack) {
                return DownloadAssetService.getAssetUri(
                    defaultCCTrack.assetId,
                    DownloadAssetService.AssetType.Document,
                    DownloadAssetService.ContentUse.Source).then((assetUriData) => {
                        return [{
                            label: defaultCCTrack.dropdownLabel,
                            source: assetUriData.uri,
                            kind: 'captions'
                        }];
                });
            }
            return $q.when([]);
        };

        self.getPermissions = function (clip) {
            var userPromise = PermissionsService.getCurrentUser();
            var writePromise = PermissionsService.canWrite(CLIP_TABS_VIEW_STATE);
            var collabWritePromise = PermissionsService.canRead(CLIP_COLLABORATORS_VIEW_STATE);
            var distWritePromise = PermissionsService.canRead(CLIP_DISTRIBUTIONGRID_VIEW_STATE);
            var advancedWritePromise = PermissionsService.canRead(ADVANCED_LIVE_CLIP_PACKAGE_DISTRIBUTIONGRID_VIEW_STATE);
            var adHocWritePromise = PermissionsService.canWrite(PACKAGE_AD_HOC_ADD_PARTNERS_VIEW_STATE);
            var downloadViewStatePromise = PermissionsService.getPackagePermissions(DOWNLOAD_PROXY_STATE, self.packageObject.id);

            var allPromise = $q.all({
                user: userPromise,
                livePerms: writePromise,
                collabPerms: collabWritePromise,
                distPerms: distWritePromise,
                advancedDistPerms: advancedWritePromise,
                adHocPerms: adHocWritePromise,
                downloadProxy: downloadViewStatePromise
            });

            allPromise.then(function (perms) {
                self.viewModel.perms.userId = perms.user && perms.user.id;
                self.viewModel.perms.livePerms = perms.livePerms;
                self.viewModel.perms.collabPerms = perms.collabPerms;
                self.viewModel.perms.distPerms = perms.distPerms;
                self.viewModel.perms.advancedDistPerms = perms.advancedDistPerms;
                self.viewModel.perms.adHocPerms = perms.adHocPerms;
                self.viewModel.perms.downloadProxy = perms.downloadProxy[0];
            });

            return allPromise;
        };

        self.feedDropdownLabelFxn = function (feed, feedSchedule, shortLabel) {
            var startTime = '', stopTime = '', feedName = (feed && feed.liveFeed) ? feed.liveFeed.name : '';
            var timeString = '';
            if (!shortLabel && feedSchedule && feedSchedule.startTime && feedSchedule.stopTime) {
                startTime = $filter('amDateFormat')(feedSchedule.startTime, 'MMM DD hh:mm A');
                stopTime = $filter('amDateFormat')(feedSchedule.stopTime, 'hh:mm A');
                timeString = ' ' + startTime + ' - ' + stopTime;
            }
            return feedName + timeString + ((feed.defaultFlag) ? ' (default)' : '');
        };

        self.getEditData = function () {
            var catTypes = PackageResourceFactory.query({sub: 'categoryTypes'}).$promise;
            var content = ContentResourceFactory.get({id: self.packageObject.content.id}).$promise;
            var mediaInfo = (self.packageObject.primaryVideo) ? SystemMediainfoResource.get({id: self.packageObject.primaryVideo.assetId}).$promise : null;
            var pkgMedia = PreviewQueryService.getPackageMedia(self.packageObject.id);
            return $q.all({content: content, catType: catTypes, media: mediaInfo, pkgMedia: pkgMedia})
                .then(function (editData) {
                    self.categoryTypes = editData.catType;
                    self.viewModel.availableFeeds = [];
                    self.packageMedia = editData.pkgMedia['Main Video'];

                    if (self.packageObject.primaryVideo) {
                        self.viewModel.availableFeeds.push({
                            label: self.packageObject.primaryVideo.acceptTemplateMember.acceptProfile.name,
                            isLive: false,
                            framerate: editData.media.frameRate,
                            width: editData.media.width,
                            height: editData.media.height
                        });
                        self.defaultFeed = self.viewModel.availableFeeds[0];
                    }
                    angular.forEach(self.packageObject.liveRecordSchedules, function (schedule) {
                        angular.forEach(editData.content.liveFeeds, function (feed) {
                            if (schedule.showLiveFeedId === feed.id) {
                                var wrappedFeed = {
                                    label: self.feedDropdownLabelFxn(feed, schedule),
                                    shortLabel: self.feedDropdownLabelFxn(feed, schedule, true),
                                    isLive: true,
                                    id: feed.id,
                                    feedData: feed
                                };
                                if (feed.defaultFlag && !self.defaultFeed) {
                                    self.defaultFeed = wrappedFeed;
                                }
                                self.viewModel.availableFeeds.push(wrappedFeed);
                            }
                        });
                    });
                    self.viewModel.currentFeed = self.defaultFeed || self.viewModel.availableFeeds[0];
                    if (self.packageObject.liveRecordSchedules && self.packageObject.liveRecordSchedules.length &&
                        self.viewModel.currentFeed.isLive) {
                        self.viewModel.feedScheduleMap = buildFeedScheduleMap(self.viewModel.availableFeeds, self.packageObject.liveRecordSchedules);
                        self.currentSchedule = self.viewModel.feedScheduleMap[self.viewModel.currentFeed.id].schedule;
                        return getRecordAndClipData(self.currentSchedule.liveRecordId);
                    } else {
                        return self.refreshClips();
                    }
                });
        };

        self.updateSchedule = function (recordMap) {
            var saveFinished = $q.defer();
            var savePromises = {};
            angular.forEach(self.packageObject.liveRecordSchedules, function (schedule) {
                if (schedule.liveRecordOverridden && recordMap[schedule.liveRecordId]) {
                    var recordToSave = recordMap[schedule.liveRecordId];
                    recordToSave.startTime = schedule.startTime;
                    recordToSave.stopTime = schedule.stopTime;
                    savePromises[schedule.liveRecordId] = recordToSave.$update();
                }
            });
            savePromises.packageSave = self.packageObject.$save();
            $q.all(savePromises).then(function (savedObjects) {
                self.viewModel.feedScheduleMap = buildFeedScheduleMap(self.viewModel.availableFeeds, self.packageObject.liveRecordSchedules);
                self.updateFeedLabel = true;
                pollForRecord();
                saveFinished.resolve(savedObjects);
            });

            return saveFinished.promise;
        };

        self.stopCancelRecord = function (record) {
            var recordPromise = (record.status === 'running') ? record.$stop() : record.$delete();
            var packageSave = self.packageObject.$save();
            return $q.all([recordPromise, packageSave]).then(function () {
                return pollForRecord();
            });
        };

        var checkIfPackageSaveRequired = function () {
            return self.metadataForm.$dirty || !angular.equals(self.viewModel.clipInEdit, self.originalClipEditData);
        };
        let setClipData = () => {
            self.viewModel.clipInEdit.packageData.clipStartOffset = self.viewModel.clipInEdit.clipStartOffset;
            self.viewModel.clipInEdit.packageData.clipEndOffset = self.viewModel.clipInEdit.clipEndOffset;
            self.viewModel.clipInEdit.packageData.clipImageFromTimecode = !!self.viewModel.clipInEdit.clipImageOffset;
            self.viewModel.clipInEdit.packageData.clipImageOffset = self.viewModel.clipInEdit.clipImageOffset;
            self.viewModel.clipInEdit.packageData.clipThumbnailData = self.viewModel.clipInEdit.tempThumbnail;

            if (self.viewModel.currentFeed && self.viewModel.currentFeed.isLive) {
                self.viewModel.clipInEdit.packageData.liveRecordId = self.viewModel.record.id;
            }
        };

        let savePackageResource = () => {
            return PackageResourceFactory.save({id: self.viewModel.clipInEdit.packageData.id},
                self.viewModel.clipInEdit.packageData).$promise
                .then(function (data) {
                    self.viewModel.clipInEdit.packageData = data;
                    self.originalClipEditData.packageData = angular.copy(self.viewModel.clipInEdit.packageData);
                    PackageUtilService.createErrorsAndWarningsMap(self.viewModel.clipInEdit.packageData.validationResult);
                    return data;
                });
        };

        var saveClipPackage = function (isDraftClip, useDraftClip) {
            if (isDraftClip) {
                setClipData();
                return ClipResourceFactory.createDraftClip({
                    id: self.viewModel.clipInEdit.packageData.parentPackageId,
                    name: self.viewModel.clipInEdit.packageData.name,
                    title: self.viewModel.clipInEdit.packageData.title,
                    numberOfClips: self.viewModel.clipInEdit.packageData.numberOfClips,
                    scheduleId: self.packageObject.liveRecordSchedules.map(function (schedule) {
                        return schedule.id;
                    })
                }, self.viewModel.clipInEdit.packageData).$promise
                    .then(function (data) {
                        self.viewModel.clipInEdit.packageData = data;
                        self.originalClipEditData.packageData = angular.copy(self.viewModel.clipInEdit.packageData);
                        PackageUtilService.createErrorsAndWarningsMap(self.viewModel.clipInEdit.packageData.validationResult);
                        return data;
                    });

            } else {
                if (useDraftClip) {
                    return PackageResourceFactory.get({id: self.viewModel.clipInEdit.packageData.id}).$promise.then((data) => {
                        self.viewModel.clipInEdit.packageData = data;
                        setClipData();
                        return savePackageResource();
                    });
                } else {
                    setClipData();
                    return savePackageResource();
                }
            }
        };

        var offsetModified = function (propName) {
            var orig = parseFloat(self.originalClipEditData.packageData[propName]);

            //The 'orig' seconds (above) can be rounded to 2-3 decimal places.  The 'current' seconds need to be rounded
            //the same otherwise any clip package save will result in a re-extraction of media.
            var current = parseFloat(self.viewModel.clipInEdit[propName]);
            var currentFormatted = parseFloat(current.toFixed(orig.toString().split('.')[1].length));
            return (orig !== currentFormatted) && !(isNaN(orig) && isNaN(currentFormatted));
        };

        self.requiresResetAfterSave = function () {
            return (
                offsetModified('clipStartOffset') ||
                offsetModified('clipEndOffset') ||
                offsetModified('clipImageOffset'));
        };

        self.resetClip = function () {
            return ClipResourceFactory.resetClip({id: self.viewModel.clipInEdit.id});
        };

        self.onSave = function () {
            var distributionData = null, partnerPromise = null, advancedPromise = null, thumbnailPromise = null,
                advancedData = null, collaboratorsPromise = null, collaboratorsData = null;
            var packagePromise = (checkIfPackageSaveRequired()) ? saveClipPackage() : null;

            if (self.viewModel.clipInEdit.thumbnailObject) {
                thumbnailPromise = self.uploadThumbnail(self.viewModel.clipInEdit.packageData, self.viewModel.clipInEdit.thumbnailObject);
            }

            if (self.collaboratorsForm.$dirty) {
                collaboratorsData = PackageUtilService.subTabSaveFunctions.collaboratorsForm.data();
            }

            if (self.distributionForm.$dirty) {
                distributionData = PackageUtilService.subTabSaveFunctions.distributionForm.data();
            }

            if (self.advancedForm.$dirty) {
                advancedData = PackageUtilService.subTabSaveFunctions.advancedForm.data();
            }

            if (collaboratorsData) {
                collaboratorsPromise = PackageResourceFactory.saveCollaborators({
                    id: self.viewModel.clipInEdit.id,
                    sub: 'actors'
                }, collaboratorsData).$promise;
            }

            if (distributionData) {
                partnerPromise = PackageResourceFactory.savePartnerPackages({
                    id: self.viewModel.clipInEdit.id,
                    sub: 'partnerPackages'
                }, distributionData).$promise;
            }

            if (advancedData) {
                advancedPromise = PackageResourceFactory.savePartnerPackages({
                    id: self.viewModel.clipInEdit.id,
                    sub: 'partnerPackages'
                }, advancedData).$promise;
            }

            var allPromise = $q.all({
                pkg: packagePromise,
                partners: partnerPromise,
                advanced: advancedPromise,
                collaborators: collaboratorsPromise,
                thumbnail: thumbnailPromise
            });

            return allPromise.then(function (data) {
                if (self.distributionForm.$dirty) {
                    PackageUtilService.subTabSaveFunctions.distributionForm.callback();
                    self.distributionForm.$setPristine();
                } else if (self.advancedForm.$dirty) {
                    PackageUtilService.subTabSaveFunctions.advancedForm.callback();
                    self.advancedForm.$setPristine();
                }
                if (self.collaboratorsForm.$dirty) {
                    PackageUtilService.subTabSaveFunctions.collaboratorsForm.callback(data.collaborators);
                    self.collaboratorsForm.$setPristine();
                }
                self.viewModel.clipInEdit.thumbnailObject = null;
                self.metadataForm.$setPristine();
                PackageUtilService.editorForm.$setPristine();
            });
        };

        self.uploadThumbnail = function (clipPackage, thumbnailObject) {
            return ClipResourceFactory.uploadThumbnail({id: clipPackage.id}, thumbnailObject).$promise;
        };

        self.exitEditClipMode = function () {
            var lockPromise = (self.viewModel.clipInEdit.id) ? PackageResourceFactory.removeLock({id: self.viewModel.clipInEdit.id}).$promise : null;
            return $q.when(lockPromise).then(function () {
                self.viewModel.clipInEdit = {};
                PartnerPackagesService.partnerPackages([]);
                self.originalClipEditData = {};
                return self.refreshClips();
            });
        };

        self.createNewClip = function (clip, draftClip) {
            self.viewModel.clipInEdit.packageData = {
                name: draftClip ? createDraftClipName(clip.title) : clip.name,
                title: clip.title || '',
                numberOfClips: clip.numberOfClips,
                scheduleId: draftClip ? self.packageObject.liveRecordSchedules.map(function (schedule) {
                    return schedule.id;
                }) : [],
                content: self.packageObject.content,
                categoryType: self.categoryTypes.filter(function (categoryType) {
                    return categoryType.name === 'Short Form';
                })[0],
                parentPackageId: self.packageObject.id,
                autoDeliver: true,
                purgeOnIngest: true
            };
            return saveClipPackage(draftClip).then(function (clipPackage) {
                if (self.viewModel.clipInEdit.thumbnailObject) {
                    return self.uploadThumbnail(clipPackage, self.viewModel.clipInEdit.thumbnailObject).then(function () {
                        self.viewModel.clipInEdit = {};
                        return self.refreshClips();
                    });
                } else {
                    self.viewModel.clipInEdit = {};
                    return self.refreshClips();
                }
            });
        };

        self.createDraftClip = function (draftClip) {
            return self.createNewClip(draftClip, true);
        };

        self.createInitialLiveClipName = function () {
            return self.viewModel.record.name + '-' + self.viewModel.clips.length;
        };

        self.createInitialClipName = function () {
            return self.packageObject.content.prefix +
                ' ' + moment(new Date()).format('YYYYMMDD') +
                ' ' + self.packageObject.id +
                '-' + self.viewModel.clips.length;
        };

        self.assignMarkPointsToDraftClip = function (draftClip) {
            var clipData = {
                markIn: self.viewModel.clipInEdit.clipStartOffset,
                markOut: self.viewModel.clipInEdit.clipEndOffset
            };
            if (draftClip) {
                self.viewModel.clipInEdit.packageData = draftClip;
                return saveClipPackage(false, true).then(function () {
                    return self.refreshClips();
                });
            } else {
                clipData.name = self.viewModel.record ? self.createInitialLiveClipName() : self.createInitialClipName();
                return self.createNewClip(clipData);
            }
        };

        self.removeDraftClip = function (draftClip) {
            var removeComplete = $q.defer();
            PackageResourceFactory.toggleArchive({id: draftClip.id}).$promise.then(function (pkg) {
                return self.refreshClips();
            }).then(function () {
                removeComplete.resolve();
            });
            return removeComplete.promise;
        };

        self.acceptClip = function (clip, deliverClip) {
            var acceptFn = ClipResourceFactory[
                deliverClip ? 'acceptAndDeliverClip' : 'acceptClip'
                ];
            var deliverComplete = $q.defer();
            clip.acceptStatus = 'ACCEPTED';
            acceptFn({id: clip.id}).$promise.then(function (clip) {
                $interval(delayedPollForClips, 500, 1, true, deliverComplete);
            });
            return deliverComplete.promise;
        };

        self.getEditClipData = function (clip) {
            var editDataComplete = $q.defer();
            var promises = {
                clip: PackageResourceFactory.get({id: clip.id, lock: true}).$promise,
                partnerPackages: PartnerPackagesService.queryPartnerPackages(clip.id)
            };

            $q.all(promises).then(function (data) {
                var framerate = 0;
                if (self.viewModel.record) {
                    framerate = self.viewModel.record.framerate;
                } else if (self.viewModel.currentFeed) {
                    framerate = self.viewModel.currentFeed.framerate;
                }
                self.viewModel.clipInEdit = {
                    id: data.clip.id,
                    packageData: data.clip,
                    liveClipId: data.clip.liveClipId,
                    clipStartOffset: parseFloat(data.clip.clipStartOffset),
                    clipEndOffset: parseFloat(data.clip.clipEndOffset),
                    markInTimeCode: (data.clip.clipStartOffset > -1) ? timecodeFromSecFilter(data.clip.clipStartOffset, framerate) : '',
                    markOutTimeCode: (data.clip.clipEndOffset) ? timecodeFromSecFilter(data.clip.clipEndOffset, framerate) : '',
                    clipImageOffset: data.clip.clipImageOffset,
                    imageTimeCode: timecodeFromSecFilter(parseFloat(data.clip.clipImageOffset), framerate),
                    primaryImage: data.clip.primaryImage,
                    clipDuration: timecodeFromSecFilter(clip.clipDuration, framerate),
                    validationResult: filterClipValidationResults(data.clip.validationResult),
                    liveClipTempThumbnailPath: data.clip.liveClipTempThumbnailPath,
                    liveRecordId: data.clip.liveRecordId,
                    tempThumbnail: data.clip.clipThumbnailData
                };

                PartnerPackagesService.partnerPackages(data.partnerPackages);
                PackageUtilService.createErrorsAndWarningsMap(self.viewModel.clipInEdit.validationResult);
                self.originalClipEditData = angular.copy(self.viewModel.clipInEdit);
                editDataComplete.resolve(self.viewModel.clipInEdit);
            });

            return editDataComplete.promise;
        };

        self.getClipFeed = function (clip) {
            if (clip.liveRecordId) {
                var clipSchedule = self.packageObject.liveRecordSchedules.filter(function (schedule) {
                    return schedule.liveRecordId === clip.liveRecordId;
                })[0];
                return self.viewModel.availableFeeds.filter(function (feed) {
                    return feed.id === clipSchedule.showLiveFeedId;
                })[0];
            } else {
                return self.viewModel.availableFeeds.filter(function (feed) {
                    return !feed.isLive;
                })[0];
            }
        };

        self.switchToClipFeed = function (clip) {
            self.viewModel.currentFeed = self.getClipFeed(clip);

            self.currentSchedule = self.packageObject.liveRecordSchedules.filter(function (schedule) {
                return schedule.showLiveFeedId === self.viewModel.currentFeed.id;
            })[0];
            return self.getRecordData(self.currentSchedule.liveRecordId);
        };

        self.switchCurrentSchedule = function () {
            self.currentSchedule = self.packageObject.liveRecordSchedules.filter(function (schedule) {
                return schedule.showLiveFeedId === self.viewModel.currentFeed.feedData.id;
            })[0];
            return self.getRecordData(self.currentSchedule.liveRecordId);
        };

        self.switchToPrimaryVideoFeed = function () {
            self.currentSchedule = null;
            self.viewModel.record = null;
        };

        self.revertData = function () {
            if (self.metadataForm.$dirty) {
                self.viewModel.clipInEdit.packageData = angular.copy(self.originalClipEditData.packageData);
            }
            if (self.collaboratorsForm.$dirty) {
                PackageUtilService.subTabRevertFunctions.collaboratorsForm();
            }
            if (self.distributionForm.$dirty) {
                PackageUtilService.subTabRevertFunctions.distributionForm();
            }
            if (self.advancedForm.$dirty) {
                PackageUtilService.subTabRevertFunctions.advancedForm();
            }
            if (PackageUtilService.editorForm.$dirty) {
                self.viewModel.clipInEdit = angular.copy(self.originalClipEditData);
            }

            self.metadataForm.$setPristine();
            self.collaboratorsForm.$setPristine();
            self.distributionForm.$setPristine();
            self.advancedForm.$setPristine();
            PackageUtilService.editorForm.$setPristine();
        };

        self.unlockClip = function (clip) {
            if (PermissionsService.isAdmin()) {
                PackageResourceFactory.removeLock({id: clip.id});
            }
        };

        self.cleanup = function () {
            $interval.cancel(clipsInterval);
            $interval.cancel(recordInterval);
            self.viewModel.clipInEdit = {};
            PartnerPackagesService.partnerPackages([]);
            self.originalClipEditData = {};
            self.viewModel = {
                perms: {livePerms: false, distPerms: false},
                record: null,
                clips: [],
                draftClips: [],
                totalClipsDuration: 0,
                currentFeed: {},
                clipInEdit: {},
                feedScheduleMap: {},
                availableFeeds: [],
                showClipsLoading: false
            };
            self.packageObject = null;
            self.defaultFeed = null;
        };
    });
